/* tslint:disable */
/* eslint-disable */
/**
 * LogQS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Record } from "./Record";
import { RecordFromJSON, RecordFromJSONTyped, RecordToJSON } from "./Record";

export interface RecordDataResponse {
  data: Record;
}

export function RecordDataResponseFromJSON(json: any): RecordDataResponse {
  return RecordDataResponseFromJSONTyped(json);
}

export function RecordDataResponseFromJSONTyped(json: any): RecordDataResponse {
  if (json == null) {
    return json;
  }

  return {
    data: RecordFromJSON(json["data"]),
  };
}

export function RecordDataResponseToJSON(
  value: RecordDataResponse | null | undefined,
): any {
  if (value == null) {
    return value;
  }

  return {
    data: RecordToJSON(value.data),
  };
}
